import React from 'react';
import AddEditContactModal from '../add-edit-contact/add-edit-contact-modal';
import { useManageContactHook } from './useManageContactHook';
import { SnackBar } from '@orijinworks/frontend-commons';

const ManageContact = (props) => {
    const {
        isLoading,
        residents,
        initialValues,
        onSubmitHandler,
        onCloseHandler
    } = useManageContactHook(props);
    const { isAddVideoContactOpen } = props;
    return (
        <>
            {isAddVideoContactOpen && (
                <AddEditContactModal
                    initialValues={initialValues}
                    isLoading={isLoading}
                    residents={residents}
                    onClose={onCloseHandler}
                    onSubmit={onSubmitHandler}
                />
            )}

        </>
    );
};

export default ManageContact;